/*LIBRARY*/
import { useEffect, useState, useCallback } from "react";
import { connect } from "react-redux";

/*COMPONENT*/
import Modal from "../common_modal/Modal";
import EDIT_LAYER_STYLE_1 from "./EDIT_LAYER_STYLE_1";
import EDIT_LAYER_STYLE_2 from "./EDIT_LAYER_STYLE_2";
import EDIT_LAYER_STYLE_3 from "./EDIT_LAYER_STYLE_3";
import FLOAT_MENU from "../common_trivial/FLOAT_MENU";

/*REDUX*/
import { getDetailLayerById } from "../../App/actions/get_features_action";
import {
  set_value_properties,
  pull_style_array,
  set_is_cluster,
  set_default_style_key,
} from "../../App/actions/propertiesActions";
import { status_action } from "../../App/actions/mapActions";

/*PICTURE*/
import cluster_on from "../../Assets/png_jpg/cluster_on.png";
import cluster_off from "../../Assets/png_jpg/cluster_off.png";

/*FUNCTION*/

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/

const EDIT_LAYER_STYLE = ({
  map,
  auth,
  layer,
  project,
  properties,
  getDetailLayerById,
  set_value_properties,
  pull_style_array,
  status_action,
  set_is_cluster,
  set_default_style_key,
}) => {
  const [style_key_clicked, set_style_key_clicked] = useState("");
  const [anchor, set_anchor] = useState(null);
  const [modal_menu, set_modal_menu] = useState(false);
  const [modal_delete, set_modal_delete] = useState(false);

  const { layer_id, geo_layer_list } = layer;
  const { geo_project } = project;
  const {
    layer_style_step,
    layer_type,
    style_array,
    fields_edit_style,
    default_style_key,
    is_preview_on,
    is_cluster,
    capex_value,
  } = properties;

  const on_aggregate = useCallback(() => {
    const geo_layer =
      geo_layer_list.find((item) => item?.geo_layer?._id === layer_id)
        ?.geo_layer || {};
    const layer_type_internal = geo_layer?.type;
    let style_type = "circle";
    if (["Point", "MultiPoint"].includes(layer_type_internal)) {
      style_type = "circle";
    } else if (
      ["LineString", "MultiLineString"].includes(layer_type_internal)
    ) {
      style_type = "line";
    } else if (["Polygon", "MultiPolygon"].includes(layer_type_internal)) {
      style_type = "fill";
    }
    const features = geo_layer?.geojson?.features || [];
    const style_array_internal = geo_layer?.style_array || [];
    const default_style_key_internal = geo_layer?.default_style_key;
    const is_cluster_internal = geo_layer?.is_cluster || false;
    let fields = geo_layer?.fields || [];
    if (features.length === 0) {
      const body = {
        geo_layer_id: geo_layer._id,
        geo_project_id: geo_project._id,
        flyStatus: true,
        folder_id: "",
        capex_value: capex_value,
        geo_layer_item: geo_layer,
      };
      getDetailLayerById(body);
    } else {
      /*
      yang perlu di agregat untuk semua field:
      min: Number, agregat angka minimal untuk rekomendasi range color tipe angka
      max: Number, agregat angka maksimak untuk rekomendasi range color tipe angka
      value_array: Array, agregat semua value untuk rekomendasi color style tipe teks
      type_of_object: Object, untuk melihat presentase tipe data apakah cenderung ke angka atau teks,
                      juga untuk memberikan peringatan jika ada data campuran ada kemungkinan style tidak berjalan semestinya
                      nextnya bisa memberikan rekomendasi untuk penggantian tipe field dan juga update many feature properties untuk menyamakan semua tipe data (biasa konversi dari teks ke angka)
                      misal value= "5000" menjadi 5000
      */
      fields = fields.map((field) => {
        let value_array = [];
        let type_of_object = {};
        let type_of_array = [];
        let min;
        let max;
        let is_number_count = 0;
        features.forEach((feature, idx) => {
          const value = feature?.properties[field.key];
          if (!isNaN(value)) is_number_count = is_number_count + 1;
          let type_of = typeof value;
          function is_color(e) {
            const temporary_div = document.createElement("div");
            temporary_div.style.backgroundColor = e;
            return temporary_div.style.backgroundColor !== "";
          }
          const is_color_value = is_color(value);
          if (is_color_value) type_of = "color";
          let number = Number(value);
          number = isNaN(number) ? 0 : number;
          if (idx === 0) {
            min = number;
            max = number;
          } else {
            if (number < min) min = number;
            if (number > max) max = number;
          }
          if (!value_array?.includes(value)) value_array.push(value);
          let type_of_number = type_of_object?.[type_of] || 0;
          type_of_number = type_of_number + 1;
          type_of_object[type_of] = type_of_number;
        });
        for (const key in type_of_object) {
          type_of_array.push({ key, value: type_of_object[key] });
        }
        //generate logic
        let case_recomendation = "";
        let color_logic = "";
        let color_mode = "";
        if (
          type_of_array?.length === 1 &&
          type_of_array?.[0]?.key === "string" &&
          is_number_count === 0
        ) {
          //kasus text
          case_recomendation = "text";
          color_logic = "by_text";
          color_mode = "random";
        } else if (
          type_of_array?.length === 1 &&
          type_of_array?.[0]?.key === "color" &&
          is_number_count === 0
        ) {
          //kasus color
          case_recomendation = "color";
          color_logic = "use_existing";
          color_mode = "random";
        } else if (
          type_of_array?.length === 1 &&
          type_of_array?.[0]?.key === "number"
        ) {
          //kasus number
          case_recomendation = "number";
          color_logic = "by_number_step";
          color_mode = "light_red_to_dark_red";
        } else if (
          type_of_array?.length === 1 &&
          type_of_array?.[0]?.key === "string" &&
          is_number_count > 0
        ) {
          //kasus angka tapi di dalam format teks
          case_recomendation = "number_in_text";
          color_logic = "by_number_step";
          color_mode = "light_red_to_dark_red";
        } else if (type_of_array?.length > 1) {
          //kasus angka dan teks tercampur
          case_recomendation = "number_and_text";
          color_logic = "by_text";
          color_mode = "random";
        } else {
          //kasus lain yang belum terhandle
          case_recomendation = "unknown";
          color_logic = "by_text";
          color_mode = "random";
        }
        if (min === 0 && max === 0) {
          min = 0;
          max = 100;
        }
        return {
          ...field,
          field_key: field?.key,
          case_recomendation,
          color_logic,
          color_mode,
          value_array,
          type_of_object,
          type_of_array,
          min,
          max,
          steps: 5,
          is_number_count,
          constant_color: "#a0d062",
          style_type,
          is_cluster: false,
        };
      });
    }
    const fields_style = fields.filter((item) => !!item.isStyle);
    fields = fields.filter((item) => !item.isStyle);
    const features_length = features?.length || 0;
    set_value_properties({
      key: "style_array",
      value: style_array_internal,
    });
    set_value_properties({
      key: "fields_edit_style",
      value: fields,
    });
    set_value_properties({
      key: "fields_style_true",
      value: fields_style,
    });
    set_value_properties({
      key: "features_length",
      value: features_length,
    });
    set_value_properties({
      key: "layer_type",
      value: layer_type_internal,
    });
    set_value_properties({
      key: "default_style_key",
      value: default_style_key_internal,
    });
    set_value_properties({
      key: "is_cluster",
      value: is_cluster_internal,
    });
  }, [
    layer_id,
    geo_layer_list,
    geo_project._id,
    capex_value,
    getDetailLayerById,
    set_value_properties,
  ]);

  useEffect(() => {
    on_aggregate();
  }, [on_aggregate]);

  useEffect(() => {
    const geo_layer =
      geo_layer_list.find((item) => item?.geo_layer?._id === layer_id)
        ?.geo_layer || {};
    const features = geo_layer?.geojson?.features || [];
    if (features?.length > 0) {
      on_aggregate();
    }
  }, [map.status_action, geo_layer_list, layer_id, on_aggregate]);

  const on_set_default_style_key_local = () => {
    const body = {
      geo_layer_id: layer_id,
      style_key: style_key_clicked,
    };
    set_default_style_key(body);
    set_modal_menu(false);
  };

  const on_set_is_cluster_local = (is_cluster_val) => {
    const body = {
      geo_layer_id: layer_id,
      is_cluster: is_cluster_val,
    };
    set_is_cluster(body);
  };

  const toggle_menu = (event) => {
    set_modal_menu(!modal_menu);
    if (event && event.target) {
      const name = event.target.name;
      set_anchor(event.currentTarget);
      set_style_key_clicked(name);
    }
  };

  const on_edit = () => {
    set_modal_menu(false);
    const style_object = style_array.find(
      (item) => item.key === style_key_clicked,
    );
    const paint_object = style_object?.paint_object || {};
    set_value_properties({
      key: "paint_object_edited",
      value: paint_object,
    });
    set_value_properties({
      key: "style_parameter",
      value: style_object,
    });
    set_value_properties({
      key: "layer_style_step",
      value: 3,
    });
  };

  const toggle_is_preview_on_local = () => {
    set_value_properties({
      key: "is_preview_on",
      value: !is_preview_on,
    });
    status_action();
  };

  const toggle_delete = () => {
    set_modal_delete(!modal_delete);
    set_modal_menu(false);
  };

  const on_pull_style_array_local = () => {
    const body = {
      geo_layer_id: layer_id,
      style_key: style_key_clicked,
    };
    pull_style_array(body);
    set_modal_delete(false);
  };

  const on_back = () => {
    set_value_properties({
      key: "layer_style_step",
      value: 0,
    });
  };

  const on_next_step = () => {
    set_value_properties({
      key: "layer_style_step",
      value: 1,
    });
    set_value_properties({
      key: "style_parameter",
      value: {
        paint_object: {},
        key: "",
        field_key: "",
        case_recomendation: "",
        color_logic: "",
        color_mode: "",
        value_array: [],
        type_of_object: {},
        type_of_array: [],
        min: 0,
        max: 0,
        steps: 5,
        is_number_count: [],
        constant_color: "#a0d062",
        style_type: "",
        is_cluster: false,
      },
    });
    set_value_properties({
      key: "paint_object_edited",
      value: {},
    });
  };

  const language = localStorage?.language || auth.language;

  let content;
  if (!layer_id) {
    content = (
      <main>
        <p className="text_medium margin_bottom">
          {dict?.["Have not selected a layer yet"]?.[language]}
        </p>
      </main>
    );
  } else if (style_array.length === 0) {
    content = (
      <main>
        <p className="text_medium margin_bottom">
          {dict?.["No styles saved yet"]?.[language]}
        </p>
      </main>
    );
  } else {
    content = (
      <main>
        <h1 className="text_bold margin_bottom">
          {dict?.["Saved styles:"]?.[language]}
        </h1>
        <table className="table full_width margin_bottom">
          <tbody>
            <tr>
              <td className="margin_bottom">
                {dict?.["Classification column name"]?.[language]}
              </td>
              <td className="margin_bottom">
                {
                  dict?.["Thematic classification logic & color scheme"]?.[
                    language
                  ]
                }
              </td>
              <td className="margin_bottom">{dict?.["Action"]?.[language]}</td>
            </tr>
          </tbody>
          <tbody className="margin_top">
            {style_array.map((item, idx) => {
              const { key, color_logic, color_mode, field_key } = item;
              const field = fields_edit_style.find(
                (element) => element.key === field_key,
              );
              return (
                <tr key={idx}>
                  <td>
                    <p className="text_bold">{field?.name}</p>
                    {key === default_style_key && (
                      <>
                        <div className="badge_small background_green">
                          Default
                        </div>
                      </>
                    )}
                  </td>
                  <td>
                    {color_logic}
                    <br />
                    {color_mode}
                  </td>
                  <td>
                    <button
                      className="button background_grey"
                      style={{ width: "30px" }}
                      onClick={toggle_menu}
                      name={key}
                    >
                      ⫶
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </main>
    );
  }

  const modal_menu_content = modal_menu && (
    <FLOAT_MENU
      id="basic-menu"
      anchorEl={anchor}
      open={modal_menu}
      onClose={toggle_menu}
      MenuListProps={{
        "aria-labelledby": "basic-button",
      }}
    >
      <div
        style={{
          padding: "0px 10px 0px 10px",
        }}
      >
        <button
          className="button hover_primary margin_bottom"
          onClick={on_edit}
        >
          {dict?.["Edit"]?.[language]}
        </button>
        <br />
        <button
          className="button hover_danger margin_bottom"
          onClick={toggle_delete}
        >
          {dict?.["Delete"]?.[language]}
        </button>
        <br />
        <button
          className="button hover_primary"
          onClick={on_set_default_style_key_local}
        >
          {dict?.["Set as default"]?.[language]}
        </button>
      </div>
    </FLOAT_MENU>
  );

  const modal_delete_content = modal_delete && (
    <Modal modalSize="small" isOpen={modal_delete} onClose={toggle_delete}>
      <div className="box-body" id="box-body">
        <h1 className="text_bold margin_bottom">
          {dict?.["Confirm delete style"]?.[language]}
        </h1>
        <br />
        <button
          className="button background_red"
          onClick={on_pull_style_array_local}
        >
          {dict?.["Delete"]?.[language]}
        </button>
      </div>
    </Modal>
  );

  return (
    <main
      className="no-drag"
      style={{
        maxHeight: "calc( 100svh - 157px )",
        overflowY: "auto",
        paddingRight: "5px",
        paddingLeft: "5px",
      }}
    >
      {modal_menu_content}
      {modal_delete_content}
      <section
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <button
          className="button_small background_black margin_bottom margin_top margin_left"
          onClick={on_back}
        >
          {dict?.["Back"]?.[language]}
        </button>
        <button
          className={`button_small margin_bottom margin_top margin_right ${
            is_preview_on ? "background_green" : "background_grey"
          }`}
          onClick={toggle_is_preview_on_local}
          data-mapid="preveiwOn"
        >
          Preview: {is_preview_on ? "On" : "Off"}
        </button>
      </section>

      <section>
        {layer_style_step === 0 && (
          <>
            <div className="text_center">
              <button
                onClick={on_next_step}
                className="button_pill background_green"
                data-mapid="clickCreateNewStyle"
              >
                <span className="badge_circle background_white">+</span>{" "}
                {dict?.["Create a new style"]?.[language]}
              </button>
            </div>
            {["Point", "MultiPoint"].includes(layer_type) && (
              <div className="margin_top">
                <br />
                <p className="text_medium margin_bottom">
                  {dict?.["Select cluster mode:"]?.[language]}
                </p>
                <section
                  className="two_container_equal"
                  style={{ height: "130px" }}
                >
                  <div
                    className={`text_center ${
                      !is_cluster ? "outline_black" : "button_white"
                    }`}
                    onClick={() => on_set_is_cluster_local(false)}
                    data-mapid="clickOffCluster"
                  >
                    <p className="margin_bottom">
                      {dict?.["Turn off cluster"]?.[language]}
                    </p>
                    <img src={cluster_off} alt="Cluster off" width="75px" />
                  </div>
                  <div
                    className={`text_center ${
                      is_cluster ? "outline_black" : "button_white"
                    }`}
                    onClick={() => on_set_is_cluster_local(true)}
                    data-mapid="clickOnCluster"
                  >
                    <p className="margin_bottom">
                      {dict?.["Turn on cluster"]?.[language]}
                    </p>
                    <img src={cluster_on} alt="Cluster on" width="75px" />
                  </div>
                </section>
              </div>
            )}
          </>
        )}
        {layer_style_step >= 1 && <EDIT_LAYER_STYLE_1 />}
        {layer_style_step >= 2 && <EDIT_LAYER_STYLE_2 />}
        {layer_style_step >= 3 && <EDIT_LAYER_STYLE_3 />}
      </section>
      {layer_style_step === 0 && <div className="margin_top">{content}</div>}
    </main>
  );
};

const mapStateToProps = (state) => ({
  map: state.map,
  auth: state.auth,
  layer: state.layer,
  loading_reducer: state.loading_reducer,
  project: state.project,
  properties: state.properties,
});

export default connect(mapStateToProps, {
  getDetailLayerById,
  set_value_properties,
  pull_style_array,
  status_action,
  set_is_cluster,
  set_default_style_key,
})(EDIT_LAYER_STYLE);
